// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.http.HttpMethod
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow
import org.mifospay.core.model.office.Office

@OptIn(InternalKtorfitApi::class)
public class _OfficeServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : OfficeService {
  override fun getOffices(): Flow<List<Office>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "offices")
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<List<Office>>>(),)!! 
  }
}

public class _OfficeServiceProvider : ClassProvider<OfficeService> {
  override fun create(_ktorfit: Ktorfit): OfficeService = _OfficeServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createOfficeService(): OfficeService = _OfficeServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
